import { processSteps } from "@/mocks/site/content";

const PROCESS_IMG =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20professional%20moving%20company%20team%20coordinating%20a%20packed%20truck%20with%20stacked%20wrapped%20furniture%20boxes%20and%20a%20clipboard%20lead%20mover%20checking%20inventory%20warm%20earth%20tones%20cream%20and%20burnt%20orange%20palette%20painterly%20texture%20artistic%20cinematic%20composition%20soft%20directional%20warm%20interior%20lighting&width=1200&height=1400&seq=site-process&orientation=portrait";

export default function ProcessSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Left: copy + steps */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              How it works
            </div>
            <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight mb-5">
              <a href="#process" className="text-ink-900 hover:text-ink-900 no-underline">
                Four steps, zero surprises.
              </a>
            </h4>
            <p className="text-base text-ink-600 leading-relaxed mb-10 max-w-xl">
              We've moved 12,000+ families and businesses. Along the way we figured out how to make the whole thing feel boring — in the best possible way.
            </p>

            <div id="process" className="space-y-5">
              {processSteps.map((step) => (
                <div
                  key={step.n}
                  className="group flex items-start gap-5 p-5 md:p-6 rounded-xl bg-cream-50 hover:bg-brand-50 border border-transparent hover:border-brand-200 transition-all"
                >
                  <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center rounded-xl bg-white border border-ink-100 group-hover:bg-brand-500 group-hover:border-brand-500 transition-colors">
                    <i className={`${step.icon} text-2xl text-ink-700 group-hover:text-white transition-colors`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-1.5">
                      <span className="text-[11px] font-display font-bold text-brand-600 tracking-widest">
                        {step.n}
                      </span>
                      <span className="h-px flex-1 bg-ink-200 max-w-[40px]"></span>
                      <h3 className="font-display text-lg md:text-xl font-bold text-ink-900">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-sm text-ink-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: image */}
          <div className="lg:col-span-5 order-1 lg:order-2 lg:sticky lg:top-24">
            <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[560px]">
              <img src={PROCESS_IMG} alt="Haulmark moving crew loading a truck" className="w-full h-full object-cover object-top" />
              {/* Floating card */}
              <div className="absolute bottom-5 left-5 right-5 md:left-6 md:right-6 bg-white/95 backdrop-blur rounded-xl p-5 border border-white/40">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-100 text-brand-600">
                    <i className="ri-shield-star-line text-xl"></i>
                  </div>
                  <div>
                    <div className="font-display font-bold text-ink-900">On-time guarantee</div>
                    <div className="text-xs text-ink-500">First hour free if we're &gt;30 min late</div>
                  </div>
                </div>
                <div className="flex items-center gap-1 mt-3">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <i key={n} className="ri-star-fill text-amber-500 text-sm"></i>
                  ))}
                  <span className="text-xs font-semibold text-ink-700 ml-1.5">4.9 from 1,847 reviews</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}